import { all, takeLatest } from 'redux-saga/effects'

/* ------------- Sagas ------------- */
import {
	authenticateWithApplicantIdSaga,
	goToFlowAuthenticateSaga,
} from './authenticationSagas'
import { deleteSmartCheckSession } from './smartCheckSessionDeletionSagas'
import { reAuthenticateSaga } from './reAuthenticationSagas'
import { checkWhiteLabelSubdomainDataSaga } from './whiteLabelSubdomainSagas'

/* ------------- Connect Types To Sagas ------------- */
export default function* root() {
	yield all([
		takeLatest(
			'smartCheckFlowOrchestrator/authenticateWithApplicantId',
			authenticateWithApplicantIdSaga,
		),
		takeLatest('smartCheckFlowOrchestrator/reAuthenticate', reAuthenticateSaga),
		takeLatest('smartCheckSession/delete', deleteSmartCheckSession),

		takeLatest(
			'smartCheckFlowOrchestrator/goToWhitelabelSubdomainLanding',
			checkWhiteLabelSubdomainDataSaga,
		),
		takeLatest('smartCheckFlowOrchestrator/goToFlow', goToFlowAuthenticateSaga),
	])
}
